"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _subNav = _interopRequireDefault(require("../sub-nav"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _default = function _default(ContentView) {
  var SubnavContentWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(SubnavContentWrapper, _React$Component);

    function SubnavContentWrapper(props) {
      var _this;

      _classCallCheck(this, SubnavContentWrapper);

      _this = _possibleConstructorReturn(this, (SubnavContentWrapper.__proto__ || Object.getPrototypeOf(SubnavContentWrapper)).call(this, props));
      _this.state = {
        subMenuConfig: []
      };
      return _this;
    }

    _createClass(SubnavContentWrapper, [{
      key: "receiveSubMenuConfig",
      value: function receiveSubMenuConfig(data) {
        if (data.length) {
          document.documentElement.classList.add('has-submenu');
        }

        this.setState({
          subMenuConfig: data
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "subnav-content-wrapper"
        }, this.state.subMenuConfig.length ? /*#__PURE__*/_react.default.createElement("div", {
          className: "sub-sidebar"
        }, /*#__PURE__*/_react.default.createElement(_subNav.default, {
          scrollableContainer: ".app-content",
          scrollTopOffset: 40,
          items: this.state.subMenuConfig,
          disableBackLink: this.props.disableBackLink
        })) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: "app-content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "grid-x grid-padding-x"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "cell"
        }, /*#__PURE__*/_react.default.createElement(ContentView, _extends({
          getSubMenuConfig: this.receiveSubMenuConfig.bind(this)
        }, this.props))))));
      }
    }]);

    return SubnavContentWrapper;
  }(_react.default.Component);

  SubnavContentWrapper.propTypes = {
    disableBackLink: _propTypes.default.bool
  };
  return SubnavContentWrapper;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/subnav-content-wrapper/index.js
// module id = 743
// module chunks = 0